export default __webpack_public_path__ + "static/media/stampDutyImg.04e5dcdd.svg";